<template>
  <div>
    <span class="field-value" v-show="!showField" @click="focusField">{{ value }}</span>
    <input
      v-model="value"
      v-show="showField"
      id="user-name"
      type="text"
      class="field-value form-control"
      @focus="focusField"
      @blur="blurField"
    >
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "fg-input-edit",
  props: ["value", "editField"],
  computed: {
    showField() {
      return this.editField;
    }
  },
  methods: {
    focusField() {
      this.editField = true;
    },
    blurField() {
      this.editField = "";
    },
    showField() {
      return this.value == "" || this.editField == false;
    }
  }
};
</script>
<style>
</style>
